function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd",
  transform: "translate(1 3)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M5,10 C4.447,10 4,10.448 4,11 C4,11.552 4.447,12 5,12 C5.553,12 6,11.552 6,11 C6,10.448 5.553,10 5,10"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M0,9 C0,8.448 0.447,8 1,8 C1.553,8 2,8.448 2,9 L2,13 C2,13.551 2.448,14 3,14 L17.998,14 L18,2.002 L2.002,2 L2.001,5 L15,5 C15.553,5 16,5.448 16,6 C16,6.552 15.553,7 15,7 L0,7 L0,2.002 C0,0.898 0.898,0 2.002,0 L17.998,0 C19.102,0 20,0.898 20,2.002 L20,13.998 C20,15.102 19.102,16 17.998,16 L3,16 C1.346,16 0,14.654 0,13 L0,9 Z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M11,12 L8,12 C7.447,12 7,11.552 7,11 C7,10.448 7.447,10 8,10 L11,10 C11.553,10 12,10.448 12,11 C12,11.552 11.553,12 11,12"
}));

var SvgBilling = function SvgBilling(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22"
    }, props), _ref)
  );
};

export default SvgBilling;